import { MenuItem } from "../interface/MenuItem";
import { Strings } from "../utility/string/string";

const DefaultLabel = "Currency:"
const Default: string = '$';
const Formats: MenuItem[] = [
    { id: 1, label: '$', icon: Strings.Empty },
    { id: 2, label: '€', icon: Strings.Empty },
    { id: 3, label: '£', icon: Strings.Empty },
    { id: 4, label: '£', icon: Strings.Empty },
    { id: 5, label: '¥', icon: Strings.Empty },
    { id: 6, label: 'CHF', icon: Strings.Empty }
]

export class Currency {
    public static get DefaultLabel(): string {
        return DefaultLabel
    }

    public static get Default(): string {
        return Default
    }

    public static get Formats(): Array<MenuItem> {
        return Formats
    }
}